export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/74cc88c7571ddfe8037db442e45677ad.svg";